export function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

export function map(from, to, s) {
  return to[0] + ((s - from[0]) * (to[1] - to[0])) / (from[1] - from[0]);
}

export function breakpoint() {
  if (767 > window.innerWidth) {
    return "mobile";
  } else if (991 > window.innerWidth && 767 < window.innerWidth) {
    return "tablet";
  } else {
    return "desktop";
  }
}
